import {t} from 'i18next';
import React from 'react';
import {IElement} from '../../../../incase-domain/elements';
import ChecklistTile from '../../../../incase-domain/components/checkbox/ChecklistTile';
import SectionTitle from '../../../elements/common/SectionTitle';
import {useHighlightedElement, useSetHighlightedElement} from '../../../../utils/hooks/slideUpdates/useSetSlideElement';

function HideOnMobile(): JSX.Element {
    const highlightedElement = useHighlightedElement() as IElement;
    const updateHighlightedElement = useSetHighlightedElement();

    return (
        <div className="l-group--form">
            <SectionTitle label={t('designSidepanel.mobileView')} />
            <ChecklistTile
                value={!!highlightedElement.hideOnMobile}
                label={t('designSidepanel.hideOnMobile')}
                help={t('designSidepanel.hideOnMobileExpl')}
                onChange={(value) => updateHighlightedElement.single('hideOnMobile', value)}
            />
        </div>
    );
}

export default HideOnMobile;
